'use client';

import { signOut } from 'next-auth/react';
import { getSignOutRedirectUrl } from './utils';

/**
 * Client-side logout handler using next-auth/react.
 * Avoids server-action serialization issues by using the client-side signOut API.
 * Revokes the session and redirects to Cognito logout.
 */
export async function clientLogout() {
  try {
    // Sign out from NextAuth (clears session)
    // The signOut function from next-auth/react handles the session invalidation
    // on the client side without requiring server-action serialization
    await signOut({
      redirect: false,
      redirectTo: '/',
    });

    // Redirect to Cognito logout URL
    const redirectUrl = getSignOutRedirectUrl();
    window.location.href = redirectUrl;
  } catch (error) {
    console.error('Logout error:', error);
    // Still redirect to logout even on error
    const redirectUrl = getSignOutRedirectUrl();
    window.location.href = redirectUrl;
  }
}
